<template>
  <div>
    <navbar-component></navbar-component>
    <main>
      <page-header title="Engineering Science"
                   :links="[{title:'Home', url:'/'},{title:'Students Club'}]"></page-header>
      <div class="container-2">
        <section class="sidebar">
          <sidebar :active="10"></sidebar>
        </section>
        <section class="content">
          <div class="heading-black1">Students Club</div>
          <tab-view>
            <tab-panel header="About"></tab-panel>
            <tab-panel header="Committee"></tab-panel>
            <tab-panel header="Activities"></tab-panel>
            <tab-panel header="Activity Plan"></tab-panel>
          </tab-view>
        </section>
      </div>
      <key-recruiters></key-recruiters>
    </main>
    <footer-component></footer-component>
  </div>
</template>
<script>
import NavbarComponent from "@/components/Navbar.vue";
import FooterComponent from "@/components/Footer.vue";
import PageHeader from "@/components/PageHeader";
import Sidebar from "@/views/academics/science/Sidebar";
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";
import KeyRecruiters from "@/components/KeyRecruiters";

export default {
  name: "Students_Club",
  components: {
    KeyRecruiters,
    NavbarComponent,
    PageHeader,
    Sidebar,
    FooterComponent,
    TabView,
    TabPanel
  },
  data() {
    return {}
  }
}
</script>
<style lang="scss" scoped/>
